import gql from "graphql-tag";

const Color = ` {
    r
    g
    b
    a
  }
`
  

const customText = `
  text
  font_size
  color {
    r
    g
    b
    a
  }
`

const GET_SHOP_SETTINGS = gql`
  query GetShopSettings($userId: ID!) {
    shop(id: $userId) {
      id
      userId
      settings {
        active
        productId
        icon {
          isExternal
          image
        }
        title {
          ${customText}
        }
        subtitle{
          ${customText}
        }
        unselectedMessage{
          ${customText}
        }
        selectedMessage{
          ${customText}
        }
        pricing{
          type
          value
        }
        checker_type
        checker_position
        offer_position
        pre_select
        product_description{
          ${customText}
        }
        tooltip {
          active
          withLink
          linkText{
            ${customText}
          } 
          link
          background  ${Color}
          symbol  ${Color}
        }
        priceStep
        priceMin
        smartprotect
      }
      money_format
      sales
      transactions
      chargeCreated
      chargeConfirmationUrl
      chargeAccepted
    }
  }
`;

export default GET_SHOP_SETTINGS;
